namespace RecordShield.Workspace {
    export interface ClientAnalyticsRow {
        ID?: number;
        AnalyticsId?: number;
        ActivationLogId?: number;
        ActivationId?: number;
        ProductId?: number;
        ProductName?: string;
        ProductItemId?: number;
        ContentKey?: number;
        StartedAt?: string;
        EndedAt?: string;
        WatchDurationInSeconds?: number;
        Sync?: boolean;
        IsFranchisee?: boolean;
        SyncDate?: string;
        ContentLength?: number;
        ContentName?: string;
        Subscriber?: string;
        SubscriberEmail?: string;
        SubscriberMobile?: string;
        ProductOwner?: string;
        ProductOwnerId?: number;
        SerialKey?: string;
        TenantId?: number;
    }

    export namespace ClientAnalyticsRow {
        export const idProperty = 'ID';
        export const localTextPrefix = 'Workspace.ClientAnalytics';

        export namespace Fields {
            export declare const ID: string;
            export declare const AnalyticsId: string;
            export declare const ActivationLogId: string;
            export declare const ActivationId: string;
            export declare const ProductId: string;
            export declare const ProductName: string;
            export declare const ProductItemId: string;
            export declare const ContentKey: string;
            export declare const StartedAt: string;
            export declare const EndedAt: string;
            export declare const WatchDurationInSeconds: string;
            export declare const Sync: string;
            export declare const IsFranchisee: string;
            export declare const SyncDate: string;
            export declare const ContentLength: string;
            export declare const ContentName: string;
            export declare const Subscriber: string;
            export declare const SubscriberEmail: string;
            export declare const SubscriberMobile: string;
            export declare const ProductOwner: string;
            export declare const ProductOwnerId: string;
            export declare const SerialKey: string;
            export declare const TenantId: string;
        }

        ['ID', 'AnalyticsId', 'ActivationLogId', 'ActivationId', 'ProductId', 'ProductName', 'ProductItemId', 'ContentKey', 'StartedAt', 'EndedAt', 'WatchDurationInSeconds', 'Sync', 'IsFranchisee', 'SyncDate', 'ContentLength', 'ContentName', 'Subscriber', 'SubscriberEmail', 'SubscriberMobile', 'ProductOwner', 'ProductOwnerId', 'SerialKey', 'TenantId'].forEach(x => (<any>Fields)[x] = x);
    }
}
